export default /(^\+[0-9]{2}|^\+[0-9]{2}(0)|^\+[0-9]{2}(0)|^00[0-9]{2}|^0)([0-9]{9}$|6-[0-9]{8}$|[0-9]{2}-[0-9]{7}$|[0-9]{3}-[0-9]{6}$)/;
